<template>
    <!-- Contact -->
    <div id="contact" class="form" style="background-color:#2f2c3d;">
        <div class="container">
            <img style="width:200px; padding-bottom:0.5em;" src="../assets/images/kickstarter.png"/>
            <div v-if="!success" class="row">
                <div class="col-lg-12">
                    
                    <h2>EARLY BIRD</h2>
                    <ul class="list-unstyled li-space-lg">
                        <li class="address">Sign up to our mailing list to get alerted when we launch our Kickstarter campaign! Make sure you get in on the early bird discounts!</li>
                    </ul>
                </div> <!-- end of col -->
            </div> <!-- end of row -->
            <div v-if="!success" class="row">
                <div class="col-lg-6 offset-lg-3">
                    <form id="contactForm" data-toggle="validator" data-focus="false">
                        <div class="form-group">
                            <input v-model="email" v-bind:class="[email ? 'notEmpty' : '']" type="email" class="form-control-input" id="cemail" required>
                            <label class="label-control" for="cemail">Email</label>
                            <div class="help-block with-errors"></div>
                        </div>
                        <div class="form-group">
                            <button @click="storeEmail" type="button" class="btn-solid-lg">Sign Up</button>
                        </div>
                        <div class="form-message">
                            <div id="cmsgSubmit" class="h3 text-center hidden"></div>
                        </div>
                    </form>
                </div> <!-- end of col -->
            </div> <!-- end of row -->
            <div v-if="success" style="color:#05ce78;font-size:1em;">Success! We will contact you when the Kickstarter campaign launches!</div>
        </div> <!-- end of container -->
    </div> <!-- end of form -->
    <!-- end of contact -->
</template>

<script>
import api from '@/api'

export default {
  name: 'ContactSection',
  data() {
      return {
          email: undefined,
          reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
          success: false
      }
  },
  methods: {
    isEmailValid() {
        return (this.email == "")? false : (this.reg.test(this.email)) ? true : false;
    },
    storeEmail () {
        if(this.isEmailValid()) {
            api.postEmail(this.email)
            this.success = true
        }
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/ContactSection.vue